import React from 'react';
import { Link } from 'react-router-dom';

import CONSTANT from '../../constant';
import Header from '../../component/common/Header';
import Paging from '../../component/common/Paging';
import { onChange, setOptions, } from '../../utils';

import { getDateParts } from '../../utils';
import { getEtourList } from '../../actions/EtourAction';

class ComponentName extends React.Component<any, any> {


    constructor(props: any) {
        super(props);
        this.state = {
            list: undefined,
            date: new Date()
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.allEtours;

        this.loadList();
    }

    render() {
        const { list, date } = this.state;
        return (

            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className='card homedob p-4 mb-4'>
                            <div className="row">
                                <div className="col-md-10">
                                    <h1 className="page-title">E-Tours in {date.getFullYear()}</h1>
                                </div>
                                <div className='col-md-2 text-end'>
                                    <Link to={CONSTANT.component.userAddETour.url} className="btn btn-sm submit-button">
                                        <i className="fa fa-plus-circle mr-2" />
                                        Apply for an E-Tour
                                    </Link>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 mt-3">
                                    <div className="list-container">
                                        <div className='table-container'>
                                            <div className='table-wrapper'>
                                                <table className="tablen">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col" style={{ width: '3%' }}>#</th>
                                                            <th scope="col">Purpose</th>
                                                            <th scope="col">Requested by</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Modified</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            list === undefined && <tr>
                                                                <td colSpan={5} className="text-center">Loading...</td>
                                                            </tr>
                                                        }

                                                        {
                                                            list !== undefined && list.length === 0 && <tr>
                                                                <td colSpan={5} className="text-center">No records found</td>
                                                            </tr>
                                                        }

                                                        {
                                                            list !== undefined && list.map((item: any, index: number) => {
                                                                const detailPageURL = CONSTANT.component.userETourDetail.url.replace(':code', item.code);
                                                                const dated = getDateParts(item.modifiedOn);
                                                                return (
                                                                    <tr key={index} className="c-pointer" onClick={() => this.openDetailPage(detailPageURL)}>
                                                                        <td>{index + 1}</td>
                                                                        <td>{item.purpose}</td>
                                                                        <td>{item.createdByName}</td>
                                                                        <td>{item.statusName ? item.statusName : 'Pending'}</td>
                                                                        <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                        <tr>
                                                            <td colSpan={5} className='p-4'>
                                                                <div className="row">
                                                                    <div className="col-md-3">
                                                                        <button type="button" onClick={this.previousYear} className="btn btn-link btn-sm next-control">Year {date.getFullYear() - 1}</button>
                                                                    </div>
                                                                    <div className="col-md-6"></div>
                                                                    <div className="col-md-3">
                                                                        <button type="button" onClick={this.nextYear} className="btn btn-link btn-sm float-right next-control">Year {date.getFullYear() + 1}</button>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }

    previousYear = () => {
        this.setState({ date: new Date(this.state.date.setFullYear(this.state.date.getFullYear() - 1)) }, () => {
            this.loadList();
        });

    }
    nextYear = () => {
        this.setState({ date: new Date(this.state.date.setFullYear(this.state.date.getFullYear() + 1)) }, () => {
            this.loadList();
        });
    }

    onChange = (e: any) => {
        onChange(this, e.target.name, e.target.value);
    }

    loadList = () => {
        const { date } = this.state;
        getEtourList(date.getFullYear()).then((res: any) => {
            if (res.status === CONSTANT.static.apiStatus.success) {
                this.setState({ list: res.result });
            } else {
                alert(res.error);
            }
        });
    }

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    }
}

export default ComponentName;